import React from "react";
import first from "../../Assets/images/first.png";
import second from "../../Assets/images/second.png";
import third from "../../Assets/images/third.png";
import fourth from "../../Assets/images/fourth.png";
import fifth from "../../Assets/images/fifth.png";
import sixth from "../../Assets/images/sixth.png";
import { motion } from 'framer-motion';

const Industry = () => {
  const motionProperties = {
    initial: "hidden",
    whileInView: "visible",
    transition: { duration: 1, delay: 0.5 },
    // viewport: { once: true }
  };

  const motionVariantsArray = [
    { hidden: { opacity: 0, y: -40 }, visible: { opacity: 1, y: 0 } },
    { hidden: { opacity: 0, x: -100 }, visible: { opacity: 1, x: 0 } },
    { hidden: { opacity: 0, x: 100 }, visible: { opacity: 1, x: 0 } },
    { hidden: { opacity: 0, y: 40 }, visible: { opacity: 1, y: 0 } },
    { hidden: { opacity: 0, rotate: -15 }, visible: { opacity: 1, rotate: 0 } },
    { hidden: { opacity: 0, scale: 0.5 }, visible: { opacity: 1, scale: 1 } }
  ];

  const industries = [
    { img: first, title: "Banking & Financial Services" },
    { img: second, title: "Consulting & Professional Service" },
    { img: third, title: "Marketing, Advertising & PR" },
    { img: fourth, title: "Technology & Engineering" },
    { img: fifth, title: "Media, Entertainment & Journalism" },
    { img: sixth, title: "Entrepreneurship & Start-Ups" }
  ];

  return (
    <React.Fragment>
      <div className="bg-gray-100 w-full h-auto overflow-hidden">
        <div className=" py-12 mx-auto max-w-7xl px-6 lg:px-8">
          <div className="flex justify-center items-center">
            <h1 className="text-[35px] text-gray-600 font-bold tracking-wider">
              INDUSTRIES
            </h1>
          </div>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 justify-center gap-8 mt-6">
            {industries.map((industry, index) => (
              <motion.div
                key={index}
                {...motionProperties}
                variants={motionVariantsArray[index % motionVariantsArray.length]}
                className="bg-gray-200 p-4 rounded-md"
              >
                <div>
                  <img src={industry.img} alt={industry.title} />
                </div>
                <div>
                  <p className="text-[20px] mt-2 font-bold text-gray-500">
                    {industry.title}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Industry;
